import { calculateIsoscelesTriangleSide } from './calculateIsoscelesTriangleSide';

import { BATWING_ANGLE, MAGIC_NUMBER } from '~/core/constants';
import { CornerInfo } from '~/core/models';

export const getEdgeLengths = (
  cos: number,
  sin: number,
  startPt: CornerInfo,
  endPt: CornerInfo
) => {
  // some tomfoolery to get the batwing angles working / TODO generalize for all angles later
  const batAdjustStart =
    startPt.angle % BATWING_ANGLE || startPt?.diagonalLength
      ? 1
      : Math.cos(Math.PI / 4) / MAGIC_NUMBER;
  const batAdjustEnd =
    endPt.angle % BATWING_ANGLE || endPt?.diagonalLength
      ? 1
      : Math.cos(Math.PI / 4) / MAGIC_NUMBER;

  // adjust the edge lengths (actual on the canvas only) if we need to account for corner radii
  const spX = startPt.coords.x;
  const spY = startPt.coords.y;
  let epX = endPt.coords.x;
  let epY = endPt.coords.y;

  if (endPt.isVisibleInCanvas) {
    if (endPt.diagonalLength) {
      // adjust side for a diagonal
      const endDiagSideLen = calculateIsoscelesTriangleSide(
        endPt.angle,
        endPt.diagonalLength
      );

      epX -= endDiagSideLen * cos * batAdjustEnd;
      epY -= endDiagSideLen * sin * batAdjustEnd;
    } else if (endPt.size && endPt.size > 0.75) {
      // adjust side for a corner radius
      epX -= endPt.size * cos * batAdjustEnd;
      epY -= endPt.size * sin * batAdjustEnd;
    }
  }

  return {
    epX,
    epY,
    spX,
    spY,
    batAdjustStart,
  };
};
